import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { formConfig } from "./formConfig";
import { ColorPicker } from "./ColorPicker";
import DimensionPicker from "./DimensionPicker";
import { ShapePicker } from "./ShapePicker";
import { LuShoppingCart } from "react-icons/lu";
import { MdAddShoppingCart } from "react-icons/md";
import { YesNoPicker } from "./YesNoPicker";

export const DynamicForm = ({ add_order, orders, openBasket }) => {
  const { register, handleSubmit,  control, reset } = useFormContext({
    defaultValues: {
      FRAME_COLOR: "RAL 9016",
      DIMENSION: {HEIGHT: 500, WIDTH: 500}
    },
  });

  console.log("rerender dynamicform");
  const onError = (errors) => {
    console.log("Form errors:", errors);
    //console.log("Form State Errors:", formState);
  };

  const onSubmit = (data) => {
    console.log("Form Data:", data);
    //console.log(formState.errors);
    add_order(data);
    //Reset form
    reset({
      DIMENSION: {HEIGHT: 1500, WIDTH: 700}
    })

    /* nog uitbreiden met kleur en gaastype vast te zetten:
    ({
  fieldName: "new value", // Specificeer de nieuwe waarde
});

*/
  };

  return (
    <>


      <div className="p-2 pb-0 overflow-y-auto	">
        <h1 className="ml-2 my-3 text-4xl font-extrabold text-blue-600 ">
         Tuin Poorten
        </h1>

        <form onSubmit={handleSubmit(onSubmit, onError)} className="space-y-2">
          {formConfig.map((con) => {
            switch (con.type) {
              case "colorPicker":
                return (
                  <Controller
                  key={con.name}
                    name={con.name}
                    control={control}
                    rules={{ required: "Colorrrrr is required" }}
                    defaultValue={con.defaultValue}
                    render={({ field, fieldState }) => (
                      <ColorPicker
                        key={con.name}
                        name={con.name}
                        label={con.label}
                        options={con.options}
                        //errors={"test"}
                        errors={fieldState?.error}
                        selectedColor={field.value}
                        //errors={errors[con.name]}
                        title={con.title}
                        detailed_label={con.detailed_label}
                        validation={con.validation}
                      />
                    )}
                  />
                );
                

              case "shapePicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue}
                  render={({ field, fieldState }) => (
                  <ShapePicker
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    options={con.options}
                    selectedColor={field.value}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    validation={con.validation}
                    errors={fieldState?.error}

                  />
                )}
                />
                );

              case "dimensionPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={{WIDTH: '500', HEIGHT: '190'}}

                  render={({ field, fieldState }) => (

                  <DimensionPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    errors={fieldState?.error}

                  />
                  )}/>
                );

              case "yesnoPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  render={({ f, fieldState }) => (
                  <YesNoPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    errors={fieldState?.error}
                    label={con.label}
                  />
                )}
                />
                  
                );

              case "text":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="text"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "number":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="number"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "checkbox":
                return (
                  <div key={con.name} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="rounded border-gray-300"
                    />
                    <label htmlFor={con.name} className="text-sm font-medium">
                      {con.label}
                    </label>
                  </div>
                );

              default:
                return null;
            }
          })}

        </form>
      </div>
    </>
  );
};
